import { AxiosInstance } from 'axios';
import { ExtendedFieldType, GenderEnum } from '../constants';
import { ActivityClothingConfig, RoleCrop, ActivityHairConfig } from '../hooks';

export type PreviewData = {
  sex: GenderEnum; // 性别
  photo_url?: string; // 头像url
  base_id: number; // 基膜id
  activity_id: number; // 活动id
  identity: number; // 身份
  cloth_figure_id: number; // 服装id
  hair_figure_id: number; // 发型id
  extended_field?: ExtendedFieldType;
};

export const getRoleServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  // 捏脸预览图获取
  getRolePreview(data: PreviewData) {
    return GateWayInstance.post<RoleCrop>('/facial_preview', data);
  },
  // 获取服装选择范围
  getIdentityRole(aid: string, type: number) {
    return GateWayInstance.get<ActivityClothingConfig & ActivityHairConfig>(`/figures/${aid}`, { params: { type } });
  },
});
